import "./SomethingMissing.scss";
import SomethingMissing from "./SomethingMissing";

export default SomethingMissing;
